import { createContext, useContext } from "react";

// <Grommet full> renders its own `height: 100vh; overflow: auto` root div -
// that's the actual scroll container, not the window/document. Grommet
// forwards a ref to it, so FunderAllocation.js attaches one and exposes a
// scrollToTop() here for both route changes and in-page tab switches
// (neither of which the browser resets scroll position for on its own).
const ScrollContext = createContext(() => {});

const useScrollToTop = () => useContext(ScrollContext);

export { ScrollContext, useScrollToTop };
